import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["StoryPointEstimator"] */ "/opt/buildhome/repo/src/app/(marketing)/tools/story-point-estimator/estimator.tsx");
